'use strict';
angular.module('cvsApp').factory('patientMessagePreferenceResponseModel',['commonModel',function(CM) {

    var patientMessagePreferenceResponseModel = function(){
        var self = this;
        var apiResponse = {};

        this.getResponse = function(){
            apiResponse = CM.getResponse();
            return self;
        }

        this.setResponse = function(data){
            CM.setResponse(data);
        }
        this.setJSONResponse = function(data){
            CM.setJSONResponse({response:  data.selfEnrollResponse});
        }

        this.getError = function(){
            if(apiResponse.showError){
                return apiResponse.showError;
            }
            return '';
        }

        var getHeader = function () {
            return apiResponse.selfEnrollResponse.header;
        }       

    }

    return new patientMessagePreferenceResponseModel();

    }]);